// Время магазина. «Сегодня», отсечка приёма и слоты считаются по часам МАГАЗИНА —
// пояс инстанса из env SHOP_TZ на сервере (в /api/settings — shop_timezone).
// Клиент может оформлять заказ из любого пояса, но получатель в городе магазина.
//
// Подстановок нет: пока настройки не пришли, пояс неизвестен, и «сегодня» не считаем —
// вызывающие ждут настроек (useShopTimezone, slotsConfig.loaded). До 30.09.2026 здесь
// были *MSK-хелперы с зашитой Москвой — наследие Стемса.
import { useEffect, useState } from 'react';
import { fetchAppSettings, getAppSettingsCached, FOREVER } from '../settings';

/** Пояс магазина из настроек инстанса; null — настройки ещё не загружены. */
export function shopTimezone() {
  return getAppSettingsCached()?.shop_timezone || null;
}

const RETRY_MS = 5000;  // настройки не пришли (сеть) — повторяем, пока компонент жив

/** Пояс магазина для компонента: null, пока настройки не пришли, затем значение. */
export function useShopTimezone() {
  const [tz, setTz] = useState(shopTimezone());
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (tz) return undefined;
    let alive = true;
    let timer = null;
    const retry = () => { timer = setTimeout(() => setAttempt((a) => a + 1), RETRY_MS); };
    fetchAppSettings({ maxAgeMs: FOREVER })
      .then((s) => { if (!alive) return; if (s.shop_timezone) setTz(s.shop_timezone); else retry(); })
      .catch(() => { if (alive) retry(); });
    return () => { alive = false; clearTimeout(timer); };
  }, [tz, attempt]);
  return tz;
}

/**
 * Текущее время в поясе tz как объект Date. tz обязателен.
 * Внимание: это «фейковая» дата — её UTC-эквивалент неправильный, но геттеры
 * getHours/getMinutes/getDate/getMonth/getFullYear/getDay вернут значения для tz.
 * Только для сравнений по часам/датам, не для отправки на сервер.
 */
export function nowInTZ(tz) {
  if (!tz) throw new Error('Пояс магазина не загружен: считать «сегодня» не по чему');
  return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
}

/** Сегодняшняя дата в поясе tz (по умолчанию — магазина) как Date с часом=0 */
export function todayShop(tz = shopTimezone()) {
  const n = nowInTZ(tz);
  return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
